import aruna from "@/../../hypetrain/static/img/aruna.jpg";
import blob1 from "@/../../hypetrain/static/img/blob1.svg";
import blob2 from "@/../../hypetrain/static/img/blob2.svg";
import blob3 from "@/../../hypetrain/static/img/blob3.svg";
import rebecca from "@/../../hypetrain/static/img/rebecca.jpg";
import sam from "@/../../hypetrain/static/img/sam.jpg";
import { Media } from "@/components/layout/Media";
import { Quotes } from "@/components/pieces/marketing/Quotes";
import { Testimonial } from "@/types/marketing";

export const QUOTES: Testimonial[] = [
  {
    quote:
      "Transformational and irreplaceable support. In a manner of months, because of the assistance I received from Placement, I moved from a dead end job into a much more interesting and well-compensated position with room to grow.",
    photo: aruna,
    name: "Aruna F.",
  },
  {
    quote:
      "Placement coached me through every stage of my job search... Once I received an incredible offer, Placement helped and encouraged me to negotiate a salary increase. Placement is on your side.",
    photo: sam,
    name: "Sam C.",
  },
  {
    quote:
      "I don't have enough words to explain how wonderful my experience has been with Placement. I do not think I could have landed the job I did and got more money on my offer without Placement.",
    photo: rebecca,
    name: "Rebecca H.",
  },
];
const BLOBS: string[] = [blob1, blob2, blob3];

export function ProQuotes() {
  return (
    <>
      <Media at="xs">
        <Quotes
          quotes={QUOTES}
          blobs={BLOBS}
          reversed={true}
          headline="Invest in yourself"
          showImages={false}
        />
      </Media>

      <Media greaterThan="xs">
        <Quotes quotes={QUOTES} blobs={BLOBS} headline="Invest in yourself" />
      </Media>
    </>
  );
}
